import { coerceArray } from '@angular/cdk/coercion';
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import {
  CanMatch,
  CanActivate,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FeatureFlagService } from '@digital-platform/util-feature-flags/services';

/**
 * To use on a route, pass  data:{
      featureFlags: 'your-ff-here',
    },
    To the route config
 */
@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard implements CanMatch, CanActivate {
  constructor(
    private featureFlags: FeatureFlagService,
    private location: Location
  ) {}

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const flags = coerceArray(route.data?.['featureFlags']);
    return this.featureFlags
      .load()
      .pipe(map(() => this.featureFlags.hasFlags(flags)));
  }

  canActivate(next: ActivatedRouteSnapshot): boolean {
    const flags = coerceArray(next.data?.['featureFlags']);
    const hasFlags = this.featureFlags.hasFlags(flags);

    if (!hasFlags) {
      this.location.back();
      return false;
    }
    return true;
  }
}
